import React, {FC, ReactNode} from 'react';
import {ListSearch} from './ListSearch';
import {ListEntityType, QueryParamsProps} from '../../constants/types';

type ListHeaderProps = {
  entity: ListEntityType,
  query: QueryParamsProps,
  filters?: ReactNode
}

const ListHeader: FC<ListHeaderProps> = ({
  entity, query, filters
}) => {
  if (!!filters) {
    return (
      <>
        {entity?.title && <h2 className="subheader">{entity.title}</h2>}
        <div className="list-header">
          {filters}
          <ListSearch
            entity={entity}
            query={query}
          />
        </div>
      </>
    );
  }

  return (
    <div className="list-header">
      <div>
        {entity?.title && <h2 className="subheader">{entity.title}</h2>}
      </div>
      <ListSearch
        entity={entity}
        query={query}
      />
    </div>
  );
};

export default ListHeader;
